import { ThemeProvider } from '@emotion/react';
import { Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { createTheme, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useAppSelector } from 'app/hooks';
import CopyToClipButton from 'components/atoms/Button/CopyToClipButton';
import NormalButton from 'components/atoms/Button/NormalButton';
import {
  HeaderUserDropZoneCards,
  ResponsiveUserDropZoneCards,
} from 'components/molecules/Card/DropZone';
import { selectAuth } from 'features/auth/authSlice';
import * as React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';

// const WhiteTextField = withStyles({
//   root: {
//     '& .MuiInputBase-input': {
//       color: '#fff', // Text color
//     },
//     '& .MuiInput-underline:before': {
//       borderBottomColor: '#fff8', // Semi-transparent underline
//     },
//     '& .MuiInput-underline:hover:before': {
//       borderBottomColor: '#fff', // Solid underline on hover
//     },
//     '& .MuiInput-underline:after': {
//       borderBottomColor: '#fff', // Solid underline on focus
//     },
//   },
// })(TextField);

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#ddb930',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const HeaderBar = styled(AppBar)(({ theme }) => ({
  position: 'relative',
  height: 'fit-content',
  paddingBottom: '10px',
  color: 'primary',
  top: '0px',
  boxShadow: 'none',
  justifyContent: 'start',
  marginBottom: '3rem',
  zIndex: '8',
}));

const Layer1 = styled(Grid)(({ theme }) => ({
  position: 'absolute',
  bottom: '-50px',
  left: '0px',
  width: '100%',
  height: '300px',
  padding: '0 5rem',
  [theme.breakpoints.down('md')]: {
    padding: '0 2rem',
  },
}));

const ParaText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#ffffff',
}));

// const TitleText = styled(Typography)(({ theme }) => ({
//   fontSize: '2.4rem',
//   fontWeight: 'bold',
//   color: '#ffffff',
// }));

const TabsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(255,255,255,0.1)',
  padding: '5px',
  [theme.breakpoints.down('lg')]: {
    padding: '3px',
  },
  borderRadius: '20px',
  width: 'fit-content',
}));

const ProfileImg = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: '250px',
  height: '250px',
  borderRadius: '50%',
  [theme.breakpoints.down('md')]: {
    width: '150px',
    height: '150px',
  },
}));

const Indicator = styled('div')(({ theme }) => ({
  width: '28px',
  height: '28px',
  borderRadius: '10px',
  background: '#ddb930',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: '10px',
}));

// const StyledBadge = styled(Badge)(({ theme }) => ({
//   '& .MuiBadge-badge': {
//     backgroundColor: '#36899f',
//     color: '#36899f',
//     '&::after': {
//       position: 'absolute',
//       top: -3,
//       left: -3,
//       width: '150%',
//       height: '150%',
//       borderRadius: '50%',
//       animation: 'ripple 1.2s infinite ease-in-out',
//       border: '1px solid currentColor',
//       content: '""',
//     },
//   },
//   '@keyframes ripple': {
//     '0%': {
//       transform: 'scale(.8)',
//       opacity: 1,
//     },
//     '100%': {
//       transform: 'scale(2.4)',
//       opacity: 0,
//     },
//   },
// }));

const BackgroundBox = styled(Box)(({ theme }) => ({
  // position: "absolute",
  // width: "100%",
  // top: "0px",
  height: '40vh',
  [theme.breakpoints.down('xl')]: {
    height: '45vh',
  },
}));

// type ContentType = {
//   gall: boolean;
//   coll: boolean;
//   back: boolean;
//   badges: boolean;
// };

// type opinionType = {
//   contact: string;
//   follow: string;
// };

const ProfileHeader: React.FC<{
  setCurrentTab: any;
  currentTab: string;
  setEditing: () => void;
  editing: boolean;
  // handleChange: (name: string, value: string) => void;
}> = ({ currentTab, setCurrentTab, setEditing, editing }) => {
  const authState = useAppSelector(selectAuth);

  const useravatar = require('assets/Profile/buku_default_avatar.png');
  const profileHeadBack = require('assets/Profile/banner.png');
  const penEditIcon = require('assets/icons/pen-edit.svg');

  const [imageUrl, setImageUrl] = React.useState<any>(useravatar);
  const [bannerUrl, setBannerUrl] = React.useState<any>(profileHeadBack);
  // const [userBanner, setUserBanner] = React.useState<string>('beta tester');

  // const history = useNavigate();

  const SetUserAvatar = (url: any): void => {
    if (url && url !== '') {
      setImageUrl(url);
    }
  };

  const SetUserHeader = (url: any): void => {
    console.log(url);
    if (url && url !== '') {
      setBannerUrl(url);
    }
  };

  // const gotoNotification = (): void => {
  //   history('/notification');
  //   // setPreviewPage("profile/gallery");
  // };

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <HeaderBar>
          <BackgroundBox>
            {editing ? (
              <HeaderUserDropZoneCards SetHeader={SetUserHeader} />
            ) : (
              <img
                src={bannerUrl ? bannerUrl : profileHeadBack}
                alt="header back"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            )}
          </BackgroundBox>
          <Layer1 container>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
              }}
            >
              {editing ? (
                <ResponsiveUserDropZoneCards SetAvatar={SetUserAvatar} />
              ) : (
                <ProfileImg
                  src={imageUrl ? imageUrl : useravatar}
                  alt="header back"
                />
              )}
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center',
              }}
            >
              <ParaText
                onClick={() => setEditing()}
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={penEditIcon.default}
                  alt="header back"
                  style={{ width: '15px', height: '15px', marginRight: '5px' }}
                />
                {editing ? 'Save Edited Changes ' : 'Profile Edit'}
              </ParaText>
            </Grid>
          </Layer1>
        </HeaderBar>

        <Grid container>
          <Grid
            item
            xs={2.5}
            sx={{
              display: 'flex',
              justifyContent: 'start',
              flexDirection: 'column',
              padding: '1rem 3rem',
              [colortheme.breakpoints.down('lg')]: {
                display: 'none',
              },
            }}
          >
            <CopyToClipButton
              text={authState.walletAddress || ''}
              style={{ width: '100%' }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            lg={9.5}
            sx={{
              padding: '1rem 3rem',
              [colortheme.breakpoints.down('lg')]: {
                padding: '1rem',
              },
              [colortheme.breakpoints.down('md')]: {
                padding: '0',
              },
            }}
          >
            <TabsWrapper>
              <Box
                style={{
                  display: 'flex',
                  gap: '4px',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                }}
              >
                <NormalButton
                  color={`${currentTab === 'Feed' ? 'yellow' : 'transparent'}`}
                  onClick={() => setCurrentTab('Feed')}
                >
                  Feed
                </NormalButton>
                <NormalButton
                  color={`${
                    currentTab === 'Collectors' ? 'yellow' : 'transparent'
                  }`}
                  onClick={() => setCurrentTab('Collectors')}
                >
                  Collectors
                  <Indicator>2</Indicator>
                </NormalButton>
                <NormalButton
                  color={`${
                    currentTab === 'Splits' ? 'yellow' : 'transparent'
                  }`}
                  onClick={() => setCurrentTab('Splits')}
                >
                  Splits
                </NormalButton>
                <NormalButton
                  isDisabled={!authState.canPost}
                  color={`${
                    currentTab === 'Backstage' ? 'yellow' : 'transparent'
                  }`}
                  onClick={() => setCurrentTab('Backstage')}
                >
                  Backstage
                  <Indicator>2</Indicator>
                </NormalButton>
                <NormalButton
                  color={`${
                    currentTab === 'Badges' ? 'yellow' : 'transparent'
                  }`}
                  onClick={() => setCurrentTab('Badges')}
                >
                  Badges
                </NormalButton>
              </Box>
            </TabsWrapper>
          </Grid>
        </Grid>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default ProfileHeader;

// {!NameEditable ? (
//   <TitleText>{userName}</TitleText>
// ) : (
//   <WhiteTextField
//     multiline
//     autoFocus
//     value={userName}
//     onChange={(event) => setUserName(event.target.value)}
//   />
// )}
